import { useLocation, matchPath } from 'react-router-dom';
import { ALL_ROUTES } from '@/Router';
import { useViewMode } from './useViewMode';

/**
 * Hook to detect if we're in totem mode AND on a detail page (Room or Artwork).
 * Used to adjust layout (e.g., remove top padding for full-bleed hero images).
 *
 * @returns Object with:
 *   - isTotemDetailView: true when in totem mode on room/artwork detail
 *   - isRoomDetail: true when on room detail page (any mode)
 *   - isArtworkDetail: true when on artwork detail page (any mode)
 */
export function useTotemDetailView() {
  const location = useLocation();
  const { isTotemMode } = useViewMode();

  const isRoomDetail = matchPath(ALL_ROUTES.room, location.pathname) !== null;
  const isArtworkDetail = matchPath(ALL_ROUTES.artwork, location.pathname) !== null;
  // const isFeedDetail = matchPath(ALL_ROUTES.feed, location.pathname) !== null;

  // const isTotemDetailView = isTotemMode && (isRoomDetail || isArtworkDetail || isFeedDetail);
  const isTotemDetailView = isTotemMode && (isRoomDetail || isArtworkDetail);

  return {
    isTotemDetailView,
    isRoomDetail,
    isArtworkDetail,
  };
}
